import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroInformacaoIntimacao extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Com informação para intimação';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        if (this.store.mapaProcessosPartes) {
            let partesProcesso = this.store.mapaProcessosPartes[registro.processo.numeroCompleto];
            if (partesProcesso?.partes) {
                return !this.semInformacaoIntimacao(partesProcesso.partes);
            }
        }
        return true;
    }

    semInformacaoIntimacao(partes) {
        return partes.findIndex((parte) => parte.semInformacaoIntimacao) !== -1;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoPartes;
    }

    renderCarregando() {
        return this.renderCircularProgress('partes dos processos');
    }
}
